import { IDataSourceBasicInfo } from '../../datasource/models/IDataSourceInfo';
import { ConnectionDetailInfo, isSameConnectionDetailInfo } from './ConnectionDetailInfo';
import { FlowBasicInfo } from './FlowInfo';
import { IContentInfo } from './IContentInfo';

export interface IDataConnectionInfoProperties {
  connectionType: string;
  connectionTypeDisplayName: string;

  connectionDetails: ConnectionDetailInfo; // The specific subtype of this object depends on the connectionDetails.type

  connectionTypeEditable: boolean;
  connectionOAuth: boolean;
  testingConnectionAllowed: boolean;
  usingRemoteQueryAgent: boolean;
}

export interface IDataConnectionInfo extends
  IDataConnectionInfoProperties,
  IContentInfo
{
  datasource?: IDataSourceBasicInfo;
  flow?: FlowBasicInfo;
}

export const isSameDataConnectionInfoProperties = (left: IDataConnectionInfoProperties) => (right: IDataConnectionInfoProperties) =>
  isSameConnectionDetailInfo(left.connectionDetails)(right.connectionDetails);
